import React from 'react';
import alertIcon from '../../../_styles/images/AlertYellow.png'
import roundInfo from '../../../_styles/images/info_rounded_trans.png'

export default function CloseMatchNotification(props) {
  const {isDesktop, vanpoolFull } = props;
  if(vanpoolFull) {
    return (
      <div role='group' className={isDesktop ? 'preferred-full-alert-box desktop' : 'preferred-full-alert-box mobile'}>
        <div className="preferred-full-alert-box-icon"><img src={roundInfo} alt='alert icon' /></div>
        <div className="preferred-full-alert-text">
          <div className="preferred-full-alert-box-heading">You’ve selected a full vanpool</div>
          <div className="preferred-full-alert-box-content">You can still request to join the vanpool and we will look into making room for you</div>
        </div>
      </div>
    );
  }else {
  return (
    <div role='group' className={isDesktop ? 'alert-box desktop' : 'alert-box mobile'}>
      <div className="alert-box-icon"><img src={alertIcon} alt='alert icon' /></div>
      <div className="alert-text">
        <div className="alert-box-heading">You’ve selected a close match</div>
        <div className="alert-box-content">Please note that this vanpool meets many of your search criteria, but not all of them</div>
      </div>
    </div>
  );
  }
}